import { ImageTargetSize } from '@tokamap/core';
import { corsImageSrc }    from '@/helpers/storageImageCrossOrigin';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default (src: string, _option?: ImageTargetSize) => corsImageSrc(src);
